
import Vue from 'vue';
import { ISelectedFilter } from "../store/state";

interface SearchFilterBtnProps {
	title: string
}
interface SearchFilterBtnComputed {
  selectedTags: number
}


export default Vue.extend<{}, {} ,SearchFilterBtnComputed ,SearchFilterBtnProps>({
	name: 'SearchFilterBtn',
	props: {
		title: {}
	},
  computed: {
    selectedTags() {
      const tags = this.$store.getters.tags
      const tag = tags.find((tag: any) => tag.title === this.title)
      const selected = tag.options.filter((option: any) => option.selected === true )

      return selected.length
    }
  }
})
